/** Limits enforced by the backend; mirrored client-side so the user sees them before saving. */
export const NAME_MAX_LENGTH = 200;
export const REMUN_CODE_DESCRIPTION_MAX_LENGTH = 50;

export const PAGE_SIZE_OPTIONS = [10, 50, 500];
export const INITIAL_PAGE_SIZE = 10;
